import { Validator } from "helpers/validator";
import { formatMessage } from "lib/globalize-util";
import { ITargetsData, ITargetsDataError, RuleType } from "components/product-collection/footer/types";

export class NoDuplicateRowsRule extends Validator<ITargetsData[], ITargetsDataError> {
    // The key will be a combination of the door and the fields selected for the target (e.g. department_number + class_number + door)
    keyField: string;

    constructor(keyField: string) {
        super();
        this.keyField = keyField;
    }

    validate(model: ITargetsData[], errors: ITargetsDataError): ITargetsDataError {
        let duplicatedRows = [];
        if (!errors[RuleType.NoDuplicateRowRule] && this.keyField) {
            duplicatedRows = [
                ...model.reduce(
                    (acc, item) => {
                        const rowId = item[this.keyField];
                        if (rowId) {
                            if (!acc.unique.has(rowId)) {
                                acc.unique.add(rowId);
                            } else {
                                acc.duplicated.add(rowId.replace(/_/g, " "));
                            }
                        }
                        return acc;
                    },
                    { unique: new Set(), duplicated: new Set() }
                ).duplicated,
            ];
        }

        const validationErrors = duplicatedRows.length
            ? {
                  ...errors,
                  [RuleType.NoDuplicateRowRule]: formatMessage(
                      "Your file contains duplicate rows for target(s): |ids|. Please remove these rows from your file.",
                      {
                          ids: duplicatedRows.join(", "),
                      }
                  ),
              }
            : errors;

        return super.validate(model, validationErrors);
    }
}
